import axiosInstance from '../../../config/axiosInstance';
const StockDiscountCategoryService = {
    async GetStockDiscountCategory(redirectCallback, StockID) {
        try {
            const response = await axiosInstance.get(`/Part/GetStockDiscountCategory?StockID=${StockID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetStockByCategoryID(redirectCallback, ID) {
        try {
            const response = await axiosInstance.get(`/Part/GetStockByCategoryID?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteStockDiscountCategory(redirectCallback, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/DeleteStockDiscountCategory?ID=${ID}`);
            return response.data;
        } catch (error) {
            
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CreateStockDiscountCategory(event, formData) {
        try {
            event.preventDefault();
            const response = await axiosInstance.post(`/Part/CreateStockDiscountCategory`, formData);
            return response.data;
        } catch (error) {            
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllStockByCategoryID(CategoryID) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllStockByCategoryID?ClientID=${ClientID}&CategoryID=${CategoryID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllCustomerByCategoryID(CategoryID) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllCustomerByCategoryID?ClientID=${ClientID}&CategoryID=${CategoryID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllSupplierByCategoryID(CategoryID) {
        try {
            const ClientID=localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllSupplierByCategoryID?ClientID=${ClientID}&CategoryID=${CategoryID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async GetAllPartsForDiscountCategory(StockCategoryID, redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Part/GetAllPartsForDiscountCategory?ClientID=${ClientID}&StockCategoryID=${StockCategoryID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
};

export default StockDiscountCategoryService;